<template>
        <v-card>
            <v-card-text>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate
                        color="primary">
                    </v-progress-circular>
                </div>
                <v-simple-table
                    dense
                    v-else>
                    <tbody>
                        <tr>
                            <th>اسم السائق</th>
                            <td>{{driver.name}}</td>
                        </tr>
                        <tr>
                            <th>رقم الهاتف</th>
                            <td>{{driver.phone}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
    name: "DriverDisplayMenu",
    props: {
        driverId: Number
    },
    data() {
        return {
            loading: {
                data: true
            }
        }
    },
    computed: {
        ...mapState("driver", ["driver"])
    },
    methods: {
        ...mapActions("driver", ["fetchDriver"])
    },
    async created() {
        await this.fetchDriver(this.driverId);
        this.loading.data = false;
    }
}
</script>